import { roundMoney } from '../../../../../../../utils/money';

import type { CategoryView } from '../../../../../../../services/categories/categories.service';
import type { OrderlineView } from '../../../../../../../services/orderlines/orderlines.service';
import type { ProductView } from '../../../../../../../services/products/products.service';

export const REPORT_GROUP_LABELS = {
  food: 'אוכל',
  beverages: 'משקאות',
  other: 'אחר',
} as const;

export type OrderReportGroupKey = keyof typeof REPORT_GROUP_LABELS;

export type OrderReportGroupBreakdownRow = {
  key: OrderReportGroupKey;
  label: string;
  amount: number;
};

export function buildAverageBreakdownRows(
  orderlines: OrderlineView[],
  products: ProductView[],
  categories: CategoryView[],
  isTakeAway: boolean,
): OrderReportGroupBreakdownRow[] {
  const productById = new Map(products.map((product) => [product.id, product]));
  const categoryById = new Map(categories.map((category) => [category.id, category]));
  const totals: Record<OrderReportGroupKey, number> = { food: 0, beverages: 0, other: 0 };

  for (const line of orderlines) {
    if (line.quantity <= 0 || (line.status === 'pending' && !isTakeAway)) {
      continue;
    }

    const product = line.productId == null ? undefined : productById.get(line.productId);
    const category = product?.categoryId == null ? undefined : categoryById.get(product.categoryId);
    const group = category?.reportGroup ?? 'other';
    totals[group] += Math.max(0, line.unitPrice * line.quantity - (line.discountInput ?? 0));
  }

  return (Object.keys(REPORT_GROUP_LABELS) as OrderReportGroupKey[])
    .map((key) => ({ key, label: REPORT_GROUP_LABELS[key], amount: roundMoney(totals[key]) }))
    .filter((row) => row.amount > 0);
}
